import { Component, Inject, Injector, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AUC_ICONS_CONFIG_TOKEN, AucIconsConfig } from "@auction-ui/config";
import { AucModelsConfig } from "@auction-ui/modelConfigs/model.config";
import { AucUserModel } from "@auction-ui/modelConfigs/user.model.config";
import { AucRootService } from "@auction-ui/root/authn/root.authn.service";
import { AucRouteNames } from "@auction-ui/route.names";
import { AucUserService } from "@auction-ui/services/user.service";
import { MfAuthService, MfBaseComponent, MfMenuItem, MfModelConfigMapped, MfModelConfigService, MfTableQueryFilterService, MfTypeInfo, MfUserPersonaCardAction } from "@pattonair/material-framework";
import { AUC_ENVIRONMENT } from "../../environments/environment";
import { AucFeatureService } from "../../services/feature.service";
import { AucSideMenuService } from "../../services/side.menu.service";


const TYPE_INFO: MfTypeInfo = { className: "AucRootAuthnComponent" };

@Component({
  selector: "ecom-root-authn",
  templateUrl: "./root.authn.component.html",
  styleUrls: ["./root.authn.component.scss"]
})
export class AucRootAuthnComponent extends MfBaseComponent implements OnInit {
  protected _userModelConfig: MfModelConfigMapped;
  protected _showFooter = true;
  protected _menuItems: MfMenuItem[] = [];
  protected _user?: AucUserModel;
  protected _userPersonaActions: MfUserPersonaCardAction[];

  public constructor(
    protected override _injector: Injector,
    protected _router: Router,
    protected _modelConfigService: MfModelConfigService,
    protected _rootService: AucRootService,
    protected _authService: MfAuthService,
    protected _userService: AucUserService,
    protected _tableQueryFilterService: MfTableQueryFilterService,
    protected _featureService: AucFeatureService,
    protected _sideMenuService: AucSideMenuService,
    @Inject(AUC_ICONS_CONFIG_TOKEN)
    protected _iconsConfig: AucIconsConfig,
  ) {
    super(TYPE_INFO, _injector);

    this._sub(this._userService.isApproved, {
      next: (isApproved) => {
        if (isApproved === false) {
          window.location.href = AUC_ENVIRONMENT.eCommerceUrl;
        }
      }
    });

    this._userPersonaActions = [
      {
        id: "logout",
        type: "action",
        title: "Log out"
      }
    ];
    this._userModelConfig = this._modelConfigService.get<AucModelsConfig>("user");
    this._sub(this._rootService.showFooterChanged, { next: (showFooter) => { this._showFooter = showFooter; } });
    this._sub(this._authService.onTokenReceived, { next: () => this._getUser() });
  }

  public ngOnInit(): void {
    this._getUser();
  }

  protected _onMenuItemClicked(menuItem: MfMenuItem): void {

  }

  protected _onPersonaActionClicked(event: MfUserPersonaCardAction): void {
    switch (event.id) {
      case "logout":
        this._authService.logout();
        break;
    }
  }

  protected _goHome(): void {
    this._router.navigate([AucRouteNames.routeHome]);
  }

  protected _getUser(): void {
    this._user = this._userService.getUser();
  }
}
